import { useReducedMotion } from '@/lib/useReducedMotion'
import PatternWaves from '@/components/ui/PatternWaves'

export function AboutValues() {
  const reducedMotion = useReducedMotion()
  return (
    <section id="beliefs" className="scroll-mt-24 border-t border-vibe-border py-16 lg:py-24">
      <div className="mx-auto max-w-6xl px-5 lg:px-8">
        <div className="section-label mb-4">01 / What it’s like to work with me</div>
        <h2 className="max-w-2xl text-3xl tracking-tight text-text-heading lg:text-5xl">Good work starts with people.</h2>
        <div className="mt-10 grid items-center gap-10 border-b border-vibe-border pb-12 md:grid-cols-2 lg:gap-20">
          <div>
            <h3 className="text-2xl text-text-heading">People and business should both win.</h3>
            <p className="mt-4 leading-relaxed text-text-secondary">I love product management because of how teams create value together. The work should help people thrive and generate business value through technology. Both matter.</p>
          </div>
          <div aria-hidden="true" className="h-64 min-w-0 md:h-80">
            <PatternWaves
              key={String(reducedMotion)}
              preset="silk"
              color="#d9dcc5"
              backgroundColor="transparent"
              fade="edges"
              interactive={!reducedMotion}
              paused={reducedMotion}
              intro={!reducedMotion}
              cursorSize={50}
              cursorStrength={0.6}
              className="beliefs-waves"
            />
          </div>
        </div>
        <div className="grid gap-10 pt-10 md:grid-cols-2 lg:gap-20">
          <article><div className="section-label mb-3">Technical depth</div><h3 className="text-xl text-text-heading">Close to the build.</h3><p className="mt-3 leading-relaxed text-text-secondary">My engineering background helps me understand what happens under the hood. I still use Figma, frontend code, and coding agents to test ideas and make tradeoffs concrete.</p></article>
          <article><div className="section-label mb-3">Practical judgment</div><h3 className="text-xl text-text-heading">Challenge the default. Know when to stop.</h3><p className="mt-3 leading-relaxed text-text-secondary">I look for better ways to do things, guided by experience and intuition. The goal is to improve our chances of success, while accepting that nothing is completely certain.</p></article>
        </div>
      </div>
    </section>
  )
}
